export default "__VITE_ASSET__BZQdMKaq__"